import { useSelector } from 'react-redux';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { getTimeInUnits } from '@/services/tools/getTimeInUnits';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';

export const useGetABWinnerInfo = () => {
    const { campaign } = useSelector(getCampainCreatorStore);

    const timeObj = getTimeInUnits(campaign?.SplitOptions?.DetermineWinnerAfterXMinutes) || null;
    const determineWinnerValue = timeObj.value || 1;
    const determineWinnerUnit = timeObj.unit || TimeUnitsEnum.Days;

    return {
        determineWinnerValue,
        determineWinnerUnit,
    };
};
